import { render } from "./DetailInstructionItem.vue?vue&type=template&id=568167e4&scoped=true&ts=true"
import script from "./DetailInstructionItem.vue?vue&type=script&lang=ts"
export * from "./DetailInstructionItem.vue?vue&type=script&lang=ts"

import "./DetailInstructionItem.vue?vue&type=style&index=0&id=568167e4&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568167e4"]])

export default __exports__